import { createFileRoute } from '@tanstack/react-router'
import { SuspendedCityPage } from '@/features/auth'

export const Route = createFileRoute('/auth/(auth)/suspended-city')({
  component: SuspendedCityRoute,
})

function SuspendedCityRoute() {
  return <SuspendedCityPage />
}
